import { 
  Container, 
  VStack, 
  Flex, 
  Box, 
  Text, 
  HStack, 
  Spacer, 
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  IconButton,
  Switch,
  MenuGroup,
  Tooltip
} from '@chakra-ui/react'
import { Timer } from './components/Timer'
import { useAuthStore } from './store/authStore'
import { useSettingsStore } from './store/settingsStore'
import { FiSettings } from 'react-icons/fi'

function App() {
  const { user, signOut } = useAuthStore();
  const { playNotificationSound, setPlayNotificationSound } = useSettingsStore();

  return (
    <Box w="100vw" minH="100vh" bg="gray.50">
      {/* Top Banner */}
      <Box w="full" borderBottom="1px" borderColor="gray.200" bg="white">
        <Container maxW="container.xl" py={3}>
          <Flex align="center" flexWrap={{ base: 'wrap', md: 'nowrap' }} gap={2}>
            <Image src="/logo.png" alt="Logo" boxSize="50px" mr={4} />
            <Text fontSize="lg" fontWeight="bold" color="gray.700">aitomato</Text>
            <Spacer />
            <HStack spacing={4} >
              {user && (
                <>
                  <Image
                    src={user.photoURL || ''}
                    alt="Profile"
                    boxSize="32px"
                    borderRadius="full"
                    fallback={
                      <Box
                        boxSize="32px"
                        borderRadius="full"
                        bg="gray.200"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Text fontSize="sm" color="gray.500">
                          {user.displayName?.charAt(0) || user.email?.charAt(0)}
                        </Text>
                      </Box>
                    }
                  />
                  <Menu placement="bottom-end" closeOnSelect={false}>
                    <Tooltip label="Settings" placement="bottom">
                      <MenuButton
                        as={IconButton}
                        aria-label="Settings"
                        icon={<FiSettings />}
                        variant="ghost"
                        size="sm"
                      />
                    </Tooltip>
                    <MenuList>
                      <MenuGroup title="User">
                        <MenuItem closeOnSelect={false} cursor="default">
                          <Flex direction="column" gap={2} width="100%">
                            <Flex align="center" gap={3}>
                              <Image
                                src={user.photoURL || ''}
                                alt="Profile"
                                boxSize="32px"
                                borderRadius="full"
                                fallback={
                                  <Box
                                    boxSize="32px"
                                    borderRadius="full"
                                    bg="gray.200"
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="center"
                                  >
                                    <Text fontSize="sm" color="gray.500">
                                      {user.displayName?.charAt(0) || user.email?.charAt(0)}
                                    </Text>
                                  </Box>
                                }
                              />
                              <Box>
                                <Text fontWeight="medium" fontSize="sm">
                                  {user.displayName}
                                </Text>
                                <Text fontSize="xs" color="gray.600" noOfLines={1}>
                                  {user.email}
                                </Text>
                              </Box>
                            </Flex>
                          </Flex>
                        </MenuItem>
                      </MenuGroup>
                      <MenuDivider />
                      <MenuGroup title="Preferences">
                        <MenuItem 
                          closeOnSelect={false}
                          onClick={() => setPlayNotificationSound(!playNotificationSound)}
                        >
                          <Flex justify="space-between" align="center" width="100%">
                            <Text>Play Sound</Text>
                            <Switch 
                              isChecked={playNotificationSound}
                              onChange={(e) => setPlayNotificationSound(e.target.checked)}
                              size="sm"
                            />
                          </Flex>
                        </MenuItem>
                      </MenuGroup>
                      <MenuDivider />
                      <MenuItem onClick={signOut} icon={<Text fontSize="sm">🚪</Text>}>
                        Sign Out
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </>
              )}
            </HStack>
          </Flex>
        </Container>
      </Box>

      {/* Main Content */}
      <Flex w="full" minH="calc(100vh - 53px)" justify="center" align="start">
        <Container maxW="container.xl" py={10} centerContent>
          <VStack spacing={8} align="center" w="100%">
            <Timer />
          </VStack>
        </Container>
      </Flex>
      {/* Footer */}
      <Box w="full" py={2} bg="gray.50" borderTop="1px" borderColor="gray.200">
        <Container maxW="container.xl" centerContent>
          <Text fontSize="xs" color="gray.500">
            Created by <a href="https://github.com/storesund" target="_blank" rel="noopener noreferrer">@storesund</a>
          </Text>
        </Container>
      </Box>
    </Box>
  )
}

export default App